import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGamingPad = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 15H10M8 13V17M18 16H18.01M15 14H15.01M16 3V6H12V9M8 21C4.68629 21 2 18.3137 2 15C2 11.6863 4.68629 9 8 9H16C19.3137 9 22 11.6863 22 15C22 18.3137 19.3137 21 16 21C14.4783 21 13.0577 20.4058 12 19.4722C10.9385 20.4223 9.53671 21 8 21Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgGamingPad;
